import React, { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import { getSignedUrl } from 'legacy/src/shared/clients/apiClient';

import { viewed } from '../shared/status';

import './image.scss';

const Player = ({ item }) => {
  const [expanded, setExpanded] = useState(false);
  const [src, setSrc] = useState(null);
  const cache = useRef({});

  const {
    content: { src: url },
  } = item;

  const {
    alt,
    caption,
    maxWidth,
    align = 'left',
    signedUrl = false,
  } = item.content;

  const toggleExpanded = () => {
    setExpanded((prevState) => ({
      expanded: !prevState.expanded,
    }));
  };

  const loadData = (nextUrl) => {
    if (!cache.current[nextUrl]) {
      cache.current[nextUrl] = getSignedUrl(nextUrl).then((result) => {
        setSrc(result);
        delete cache.current[nextUrl];
      });
    }
  };

  useEffect(() => loadData(url), [url]);

  return (
    <span
      role="button"
      tabIndex={0}
      className={cn('image', `align-${align}`, { expanded })}
      onClick={toggleExpanded}
      data-am-type="media/image"
    >
      {/* Need to always render image, even when src is null
       * to make BoxCutter think that there are some images
       **/}
      <figure className="figure">
        <img
          src={signedUrl || src}
          crossOrigin="anonymous"
          alt={alt}
          style={{ width: `'${maxWidth}px'` }}
        />
        {caption ? <figcaption>{caption}</figcaption> : null}
      </figure>
    </span>
  );
};

Player.displayName = 'Image';

export default { Player, status: viewed };
